"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkflowTag = WorkflowTag;
exports.StageVariantBasicType = void 0;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _lodash = require("lodash");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StageVariantBasicType = {
  APPLIED: 'applied',
  HIRED: 'hired',
  INTERVIEW: 'interview',
  OFFER: 'offer',
  REJECTED: 'rejected',
  REVIEW: 'review'
};
exports.StageVariantBasicType = StageVariantBasicType;

function WorkflowTag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      condensed = _ref.condensed,
      icon = _ref.icon,
      intent = _ref.intent,
      variant = _ref.variant,
      text = _ref.text,
      tagProps = _objectWithoutProperties(_ref, ["children", "className", "condensed", "icon", "intent", "variant", "text"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.CONDENSED, condensed), className);
  var intents = {
    applied: _index.Intent.NONE,
    hired: _index.Intent.SUCCESS,
    interview: _index.Intent.PRIMARY,
    offer: _index.Intent.SUCCESS,
    rejected: _index.Intent.DANGER,
    review: _index.Intent.WARNING
  };
  var icons = {
    applied: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.APPLIED,
      fill: _index.Colors.GREY_50
    }),
    hired: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.HIRED,
      fill: _index.ColorAliases.SUCCESS
    }),
    interview: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.INTERVIEW,
      fill: _index.ColorAliases.PRIMARY
    }),
    offer: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.EMAIL,
      fill: _index.ColorAliases.SUCCESS
    }),
    rejected: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.REJECTED,
      fill: _index.ColorAliases.DANGER
    }),
    review: /*#__PURE__*/React.createElement(_index.Icon16, {
      icon: _index.IconNames16.REVIEW,
      fill: _index.ColorAliases.WARNING
    })
  };
  var workflowTagProps = {
    intent: variant ? intents[variant] : intent,
    icon: variant ? icons[variant] : icon,
    minimal: true,
    round: true,
    large: true
  };
  var tagText = text ? text : (0, _lodash.capitalize)(variant);
  var caption = /*#__PURE__*/React.createElement(_index.Caption, {
    style: {
      textTransform: 'capitalize',
      color: _index.Colors.EBONY_90
    }
  }, tagText);

  if (condensed) {
    return /*#__PURE__*/React.createElement(_index.Tooltip, {
      content: tagText
    }, /*#__PURE__*/React.createElement(_index.Tag, _extends({}, tagProps, workflowTagProps, {
      className: classes
    })));
  }

  return /*#__PURE__*/React.createElement(_index.Tag, _extends({}, tagProps, workflowTagProps), caption);
}